import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

// iter 275: shared sample-warehouse list (module cache so every consumer
// shares one fetch). `reload()` after admin edits.
let cache = null;
let inflight = null;
const listeners = new Set();

async function fetchAll() {
  if (!inflight) {
    inflight = api.get("/sample-warehouses", { params: { include_inactive: true } })
      .then(({ data }) => { cache = data.items || []; listeners.forEach((fn) => fn(cache)); return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export const LAST_WAREHOUSE_KEY = "lastSampleWarehouseId";

export function useWarehouses() {
  const [warehouses, setWarehouses] = useState(cache || []);
  useEffect(() => {
    listeners.add(setWarehouses);
    if (!cache) fetchAll();
    return () => listeners.delete(setWarehouses);
  }, []);
  const reload = useCallback(() => { cache = null; return fetchAll(); }, []);
  const nameOf = useCallback((id) => (warehouses.find((w) => w.id === id) || {}).name || "", [warehouses]);
  const active = warehouses.filter((w) => w.active);
  const selectable = active.filter((w) => !w.is_default);
  return { warehouses, active, selectable, reload, nameOf };
}

export function formatWarehouseBreakdown(byWh, nameOf) {
  const entries = Object.entries(byWh || {}).filter(([, q]) => Number(q) !== 0);
  if (!entries.length) return "";
  return entries.map(([id, q]) => `${nameOf(id) || "?"}: ${q}`).join(" · ");
}
